import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { themeGet, getTextColor, getPaletteColor } from '@magalu/stereo-ui-styles';
const inputStyle = css`
  border: 1px solid;
  border-color: ${_ref => {
  let {
    hasError
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["hasError"]);

  return getPaletteColor(!hasError ? 'border.light' : 'error.base')(props);
}};
  border-radius: 4px;
  width: 100%;

  padding: ${themeGet('space.2')}px;
  line-height: ${themeGet('lineHeights.input')};
  font-size: ${themeGet('fontSizes.1')}px;

  ::placeholder {
    color: ${getTextColor('light')};
  }
`;
export const Line = styled.input`
  ${inputStyle}
`;
export const Multiline = styled.textarea.attrs(props => ({
  rows: props.rows || '5',
  cols: props.cols || '40'
}))`
  ${inputStyle}
  resize: none;
  font-family: ${themeGet('fontFamily')};
`;